const defDominio = {
  id: 1,
  sigla: "CONFED",
  uf: "SP",
  descricao: "CONFEDERAÇÃO BRASILEIRA DE BOLICHE",
  url_logo_tratado: "",
};

const federacoes = {
  localhost: defDominio,
  "192.168.0.73": defDominio,
  "fed-sc.cbbol.com.br": {
    id: 2,
    sigla: "BOLICHESC",
    uf: "SC",
    descricao: "FEDERACAO DE BOLICHE DE SANTA CATARINA - BOLICHESC",
    lourl_logo_tratadogo: "",
  },
  "boliche-pe.vercel.app": {
    id: 8,
    sigla: "FPEBOL",
    uf: "PE",
    descricao: "FEDERAÇÃO PERNAMBUCANA DE BOLICHE",
    url_logo_tratado:
      "https://sge.bolichebrasil.com.br/_uploads/estabelecimento/logo/4c053b5b1d4065cb5efcffee954f7435.png",
  },
  "boliche-ba.vercel.app": {
    id: 9,
    sigla: "FBBOL",
    uf: "BA",
    descricao: "FEDERACAO BAHIANA DE BOLICHE",
    url_logo_tratado:
      "https://sge.bolichebrasil.com.br/_uploads/estabelecimento/logo/5edcc4fe205c0dd543296eea4884849b.jpg",
  },
  "boliche-mt.vercel.app": {
    id: 10,
    sigla: "BOLICHE-MT",
    uf: "MT",
    descricao: "FEDERACAO DE BOLICHE DE MATO GROSSO",
    url_logo_tratado:
      "https://sge.bolichebrasil.com.br/_uploads/estabelecimento/logo/9b4ea0cd128141608c39b4beb66a32fd.jpg",
  },
};

export default federacoes;
